import { Link, Navigate } from 'react-router-dom';
import { usePeople } from '../api/use-people.js';
import { WaitNote } from '../components/wait-note.js';

/**
 * Who a parent's SwingReplay is for (board R7, ruled 1 November). One child
 * goes straight in; more picks one first. With no child there is nobody for a
 * practice to belong to, so SwingReplay opens as it always has.
 */
export function ToolsWhoRoute() {
  const { state } = usePeople();
  if (state.status === 'loading' || state.status === 'signed-out') return <WaitNote className="empty">Checking…</WaitNote>;
  if (state.status === 'failed') return <p className="empty">{state.message}</p>;

  const children = state.people.filter((person) => !person.is_account_holder);
  if (children.length === 0) return <Navigate to="/tools/recul" replace />;
  const only = children.length === 1 ? children[0] : undefined;
  if (only) return <Navigate to={`/tools/recul?for=${only.client_id}`} replace />;

  return (
    <>
      <div className="page-head">
        <Link className="back" to="/tools" aria-label="Back to Tools">
          ‹
        </Link>
        <div>
          <h2>Who's practicing?</h2>
        </div>
      </div>
      {children.map((child) => (
        <Link key={child.client_id} className="hour-row" to={`/tools/recul?for=${child.client_id}`}>
          <span className="hour-row-text">
            <span className="name">{child.first_name}</span>
          </span>
          <span className="chevron" aria-hidden="true">
            ›
          </span>
        </Link>
      ))}
    </>
  );
}
